import { DateFormatOptions } from 'constants/dates';

export const formatAdminSystemEventText = (eventText: string) => {
  if (DateFormatOptions.includes(eventText)) {
    return eventText.toUpperCase();
  }
  return eventText;
};
